webpackJsonp([15],{

/***/ 145:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(145);

$('html').on('click', function (event) {
  $('.nav-subnav-toggle').removeClass('is-active');
  $('.nav-subnav-menu').removeClass('is-visible');
}); /**
     * Blog JS
     */

// CSS


$('.nav-subnav').on('click', '.nav-subnav-menu-toggle', function (event) {
  event.preventDefault();
  event.stopPropagation();
  $(event.currentTarget).toggleClass('is-active');
  $('.nav-subnav-menu').toggleClass('is-visible');
});

$('.nav-subnav').on('click', '.nav-subnav-search-toggle', function (event) {
  event.preventDefault();
  event.stopPropagation();
  $(event.currentTarget).toggleClass('is-active');
  $('.nav-subnav-search').toggleClass('is-visible');

  if ($('.nav-subnav-search').hasClass('is-visible')) {
    setTimeout(function () {
      $('.nav-subnav-search .form-control').focus();
    }, 300);
  }
});

/***/ })

},[167]);


// WEBPACK FOOTER //
// blog.d1f00e03.js